import { MutInfoType } from '@kinderlabs-pos/shared-data-type';

import { posAxiosClient } from '@kinderlabs-pos/apis/axios';

export const getMutInfoListInStoreAsync = (rootUrl: string) => async () =>
	(await posAxiosClient.get<MutInfoType[]>(`${rootUrl}/mut/list/in-store/`)).data;
